import {redirect, useActionData, useLoaderData, useParams, useSubmit} from "react-router-dom";
import ModalUrlWindow from "../../../../components/modalUrl";
import {useForm} from "react-hook-form";
import api from "../../../../hooks/useApi";
import jsonToFormData from "../../../../hooks/jsonToFormData";
import {Autoform} from "../../../../components/forms/autoform";
import {Alert} from "@mui/material";
import PageTitle from "../../../../components/PageTitle";

export async function action({request, params}) {
    const formData = await request.formData();
    const actionData = {}
    try {
        const response = await api.post('/api/booking_modules/use/booking/form/', formData)
        const object_id = params.object_id;
        return redirect(`/object/${object_id}/calendar`)
    } catch (e) {
        const res = e.response;
        return {
            error: res?.data?.message || res?.data?.detail || res?.data || 'Сталася помилка',
        };
    }
    //console.log(formData);
    return null;
}

export async function loader({request, params}) {
    const searchParams = (new URL(request.url)).searchParams;
    const object_id = params.object_id;
    const bookFrom = searchParams.get('book_from');
    const bookTo = searchParams.get('book_to');
    const hotelObjName = searchParams.get('hotel')
        ? 'hotel'
        : searchParams.get('hotel_children')
            ? 'hotel_children'
            : null;
    if (!(bookFrom && bookTo && hotelObjName)) {
        return redirect(`/object/${object_id}/calendar`)
    }
    const defaultValues = {
        default_booking_from: bookFrom,
        default_booking_to: bookTo,
        default_hotel_children: searchParams.get(hotelObjName)
    }
    //defaultValues[hotelObjName] = searchParams.get(hotelObjName);
    //console.log(defaultValues)
    const form = (await api.get('/api/booking_modules/use/booking/form/')).data.forms;
    return {form, defaultValues};
}

export default function ObjectCalendarBook() {
    const loaderData = useLoaderData();
    //console.log(loaderData.defaultValues)
    const actionData = useActionData();
    const {object_id} = useParams()
    const submit = useSubmit()
    const formHook = useForm({defaultValues: {...loaderData.defaultValues}})
    const handleFormSubmit = (data) => {
        const formData = jsonToFormData(data);
        submit(formData, {
            method: 'post'
        })
    }
    return (
        <ModalUrlWindow width='sm' url={`/object/${object_id}/calendar`}
                        title={{text: "Внести бронювання"}}
        >
            <PageTitle title={`Нове бронювання: ${object_id || "ID"}`} />
            <Autoform
                formName='bookForm'
                fields={loaderData.form}
                formHook={formHook}
                onSubmit={handleFormSubmit}
            />
            {actionData?.error && (
                <Alert severity='error'>
                    {actionData.error}
                </Alert>
            )}
        </ModalUrlWindow>
    )
}
